/**
 * This version of this util file uses the models defined in bb-debit. This will replace the current util
 * once have completely migrated to bb-debit
 */

import { CardCustomization } from "/src/protos/squareup/bizbank/service";

export const getImageUriFromCardCustomization = (customization: CardCustomization): string => {
  const { imageBytes, mimeType } = customization;
  if (imageBytes == null || mimeType == null) {
    return "";
  }
  if (imageBytes.length === 0 || mimeType.length === 0) {
    return "";
  }

  const imageString = convertUint8ArrayToString(imageBytes);
  return `data:${mimeType};base64,${imageString}`;
};

export const convertUint8ArrayToString = (bytes: Uint8Array): string => {
  const bin = bytes
    .reduce((arr: string[], byte: number): string[] => {
      arr.push(String.fromCharCode(byte));
      return arr;
    }, [])
    .join("");
  return btoa(bin);
};
